<template>
  <div class="main-lossAndEfficiency">
    <b-overlay
    id="overlay-background"
          :show="show"
          rounded="sm"
    >
      <div class="div-chart">
        <VueApexCharts
          class="chart"
          width="200px"
          type="pie"
          :options="chartEfficiency"
          :series="chartEfficiency.series"
        />
        <div class="button-config-group">
          <b-button
            id="btn-outpts-configuration"
            v-if="this.user && this.user.Permissions.editarpap.allowed"
            class="button-config"
            @click="openConfigKPI"
            >{{ $t('configurar-saidas') }}</b-button
          >
          <b-button
            id="btn-loss-configuration"
            v-if="this.user && (this.user.Permissions.editarpap.allowed || this.user.Permissions.editarperdas.allowed)"
            class="button-config"
            @click="openConfigKPIUser"
            >{{ $t('configurar-perdas') }}</b-button
          >
        </div>
      </div>

      <div class="loss">
        <div class="iten-flex title">
          <p>{{ $t('perda') }}</p>
          <p v-if="!shouldShowCitrus">{{ $t('art-cana') }}</p>
          <p v-if="shouldShowCitrus">{{ $t('art-citrus') }}</p>
        </div>
        <div v-for="(l, i) in lossList" :key="i">
          <div class="iten-flex model">
            <p>{{ l.variable }}</p>
            <p>{{ l.value | ParseNumber }}</p>
          </div>
        </div>
      </div>

      <div class="indicator">
        <h5>{{ $t('indicadores') }}</h5>
        <div v-for="(ind, i) in indicatorList" :key="i">
          <div class="iten-flex model">
            <p>{{ ind.variable }}</p>
            <p>{{ ind.value | ParseNumber }}</p>
          </div>
        </div>
      </div>

      <div class="effective-production">
        <h5>{{ $t('producao-efetiva') }}</h5>
        <div class="iten-flex">
          <p class="col1"></p>
          <p class="col2 title">{{ $t('simulado') }}</p>
          <p class="col3 title">{{ $t('meta') }}</p>
        </div>
        <div v-for="(kpi, i) in kpiList" :key="i">
          <div class="iten-flex model">
            <p class="col1">{{ kpi.variable }}</p>
            <p class="col2">{{ kpi.valueTarget | ParseNumber }}</p>
            <p class="col3">{{ kpi.valueReal | ParseNumber }}</p>
          </div>
        </div>
      </div>

      <b-modal
        id="ConfigLossAndEfficiencyUser"
        size="lg"
        hide-footer
        :title="$t('configuracao-das-perdas-em-art')"
        :no-close-on-backdrop="true"
      >
        <UserConfigInput
          :determinatedList="determinatedList"
          :undeterminatedList="undeterminatedList"
          @reloadForm="init"
        />
      </b-modal>

      <b-modal
        id="ConfigInputToUser"
        size="xl"
        hide-footer
        :title="$t('configurar-mapeamentos-da-configuracao-de-perdas')"
        :no-close-on-backdrop="true"
      >
        <ConfigInput
          :determinatedList="determinatedList"
          :undeterminatedList="undeterminatedList"
          :lossList="lossList"
          :lossOthersList="lossOthersList"
        />
      </b-modal>

      <b-modal
        id="ConfigLossAndEfficiency"
        size="lg"
        hide-footer
        :title="$t('configurar-perdas')"
        :no-close-on-backdrop="true"
      >
        <ConfigOutput
          :lossList="lossList"
          :indicatorList="indicatorList"
          :kpiList="kpiList"
          :chartList="chartList"
          :updateChartCount="updateChartCount"
          @updateChart="updateChartCount = $event"
        />
      </b-modal>
    </b-overlay>
  </div>
</template>

<script>
import { ChartList, IndicatorList, KPIList, LossList, Mapping, KPI } from "./tools/InitialKpisCollection.js";
import { urlMainAPI } from "@/global";
import { parseBR } from "../../flowchart/utils/numbers.js";
import { FiltersMixin } from "../../mixins/filtersMixin";
import { mapState } from "vuex";
import ConfigOutput from "./configOutput.vue";
import ConfigInput from "./configInputToUser.vue";
import UserConfigInput from "./userConfigInput.vue";
import VueApexCharts from "vue-apexcharts";
import ChartConfig from "./tools/chart";
import axios from "axios";
import { SingletonEnginnering } from "../../flowchart/nodes/_service/singletonEngineering.js";
import LossConfiguration from './models/LossConfiguration.js';
import LossStructure from './models/LossStructure.js';

export default {
  name: "LossAndEfficiencyForm",
  components: { VueApexCharts, ConfigOutput, UserConfigInput, ConfigInput },
  mixins: [ FiltersMixin ],
  props: ["update", "sendInputsToSimulation"],
  computed: {
    ...mapState(["user"]),
    canUpdateFormLoss() {
      return this.$store.state.canUpdateFormLoss
    }
  },

  provide() {
    return {
      updateTags: this.setTagOnline,
      updateInputLossUser: this.getMappingInputLossUser
    };
  },

  data() {
    return {
      lossList: new Array(),
      lossOthersList: new Array(),
      indicatorList: new Array(),
      kpiList: new Array(),
      chartList: new Array(),
      updateChartCount: 0,
      chartEfficiency: ChartConfig,
      determinatedList: [],
      undeterminatedList: [],
      show: true,
      shouldShowCitrus: false
    };
  },

  watch: {
    updateChartCount() {
      this.loadingMappings()
      this.updateChart();
    },

    update() {
      setTimeout(() => {
        this.updateLists();
      }, 1000);
      setTimeout(() => {
        this.updateChart();
      }, 1000);
      setTimeout(() => {
        this.loadDeterminetedAndUndeterminated();
      }, 1000);
      setTimeout(() => {
        this.setTagOnline();
      }, 1000);
    },

    sendInputsToSimulation(){
      this.sendInputs()
    },

    canUpdateFormLoss() {
      this.init();
    }
  },

  methods: {
    async loadingMappings() {
      const url = `${urlMainAPI}/getmappingtoformloss`;
      await axios
        .get(url)
        .then(async (res) => {
          if (res.status == 200) {
            this.kpiList = [];
            await this.createModelMappings(res.data);
          } else if (res.status == 204) {
            this.lossList = LossList.map((m) => {
              m.setValue();
              return m;
            }).sort((a, b) => a.variable > b.variable ? 1 : a.variable < b.variable ? -1 : 0);
            this.indicatorList = IndicatorList.map((m) => {
              m.setValue();
              return m;
            });
            this.kpiList = KPIList.map((m) => {
              m.setValue();
              return m;
            }).sort((a, b) => a.variable > b.variable ? 1 : a.variable < b.variable ? -1 : 0);
            this.chartList = ChartList.map((m) => {
              m.setValue();
              return m;
            });
          }
        })
        .catch();
    },

    async getMappingInputLossUser(){

      const url = `${urlMainAPI}/getlossinputsettings`;
      await axios
        .get(url)
        .then(async (res) => {
          this.determinatedList = new Array ();
          this.undeterminatedList = new Array ();

          if (res.status == 200) {
            res.data.determinated.forEach(d => {
              let lc = new LossConfiguration(d);
              lc.setValue();
              for(let i = 0; i < d.childrens.length; i++){
                let miList = [];
                d.childrens[i].mi.forEach(mi => miList.push(new Mapping(mi)));
                lc.AddChildren(miList, new Mapping(d.childrens[i].mo))
              }
              
              this.determinatedList.push(lc)
              this.determinatedList = this.determinatedList.sort((a, b) => a.variable > b.variable ? 1 : a.variable < b.variable ? - 1 : 0)
            })
            res.data.undeterminated.forEach(u => {
              let miList = [];
              u.mi.forEach(mi => miList.push(new Mapping(mi)));
              this.undeterminatedList.push(new LossStructure(miList, new Mapping(u.mo)))
            })
          } 
        })
        .catch();
    },

    async createModelMappings(objctList) {
      this.lossList = this.setValueAndGetMapping("lossList", objctList);
      this.lossOthersList = this.setValueAndGetMapping("lossOthersList", objctList);
      this.indicatorList = this.setValueAndGetMapping("indicatorList", objctList);
      this.chartList = this.setValueAndGetMapping("chartList", objctList);
      this.setAndGetMappingKPI(objctList);
    },

    setValueAndGetMapping(name, objctList) {
      return objctList[name].map((m) => {
        let map = new Mapping({ ...m });
        map.setValue();
        return map;
      }).sort((a, b) => a.variable > b.variable ? 1 : a.variable < b.variable ? -1 : 0);
    },

    setAndGetMappingKPI(objctList) {
      let kpis = this.setValueAndGetMapping("kpiList", objctList);

      for (let i in kpis) {
        let ms = kpis[i];
        if (ms.operation == "papkps") {
          let mr = kpis.find((m) => m.operation == "papkpr" && m.variable == ms.variable);
          if (mr) {
            let kpi = new KPI(ms, mr);
            kpi.setValue();
            this.kpiList.push(kpi);
          }
        }
      }

      this.setTagOnline();
    },

    setTagOnline() {
      let tags = this.kpiList.map((m) => m.mappingReal);

      const url = `${urlMainAPI}/calculatesentence`;
      axios
        .post(url, tags)
        .then((res) => {
          if (res.status == 200) {
            Object.keys(res.data).forEach((tag) => {
              let map = this.kpiList.filter((k) => k.mappingReal == tag);
              if (map.length) map.forEach((m) => (m.valueReal = res.data[tag]));
            });
          }
        })
        .catch();
    },

    openConfigKPI() {
      this.$bvModal.show("ConfigLossAndEfficiency");
    },

    openConfigKPIUser() {
      this.$bvModal.show("ConfigLossAndEfficiencyUser");
    },

    updateChart() {
      this.chartEfficiency.series = new Array();
      this.chartEfficiency.labels = new Array();
      this.chartList.forEach((k) => {
        k.setValue();
        this.chartEfficiency.series.push(parseBR(k.value));
        this.chartEfficiency.labels.push(k.variable);
      });
    },

    updateLists() {
      this.lossList.forEach((n) => n.setValue());
      this.indicatorList.forEach((n) => n.setValue());
      this.kpiList.forEach((n) => n.setValue());
    },

    loadDeterminetedAndUndeterminated(){
      this.determinatedList.forEach(d => d.setValue())
      this.undeterminatedList.forEach(u => u.setValue())
    },

    async init(){
      setTimeout(() => {}, 1000);

      if(SingletonEnginnering.isLoaded){
        await this.loadingMappings();
        this.updateChart();
        this.show = false
        await this.getMappingInputLossUser()
      }else{
        setTimeout(this.init, 1000)
      }
    },

    sendInputs(){
      let inputMappings = []
      this.determinatedList.forEach(det => {
        inputMappings = [...det.getInputsMappings(), ...inputMappings]
      })

      this.undeterminatedList.forEach(und => {
        und.mi.forEach(mi => {
          inputMappings.push(mi)
        })
      })
      let tableInputs = inputMappings.map(map => map.getMappingAndValue())
      this.$emit("sendInputList", tableInputs);
    }
  },

  async mounted() {
    let current =  JSON.parse(localStorage.xml).scenarioObjectStructure.Operações;
    Object.keys(current).forEach(element => {
      if (element == "Custom|EX_101") 
      {
        this.shouldShowCitrus = true
      }
    });
    
    setTimeout(this.init, 1000)
  },
};
</script>

<style>

.chart>div{
  display: flex;
  align-content: center;
  justify-content: center;
  width: 100% !important;
}

</style>

<style scoped>
p {
  margin: 0;
  font-size: 0.9rem;
}

h5 {
  color: #ff5f00;
  background: #eee9;
  text-align: center;
  font-size: 0.9rem;
  margin-bottom: 2px;
}

.main-lossAndEfficiency {
  padding: 8px;
  overflow-y: auto;
  border-radius: 3px;
  border: 1px solid #0008;
  margin: 0px 0px 0px 5px;
  box-shadow: 3px 2px 7px #0008;
  height: 67vh;
}
.button-config-group,
.div-chart {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.chart{
  display: flex;
}

.button-config-group {
  margin-top: -55px;
  z-index: 1;
}

.button-config {
  align-self: flex-end;
  font-size: 0.7rem;
  margin-top: 2.5px;
  padding: 2px 4px;
  width: 100px;
  background: #ffb373;
  color: #000;
  border: none;
}

.button-config-output {
  margin-right: 108px;
}

.iten-flex {
  display: flex;
  justify-content: space-around;
  align-content: center;
}

.iten-flex > p.title,
.iten-flex.title {
  font-weight: 700;
}

.iten-flex > p {
  padding-left: 8px;
}

.iten-flex.model {
  justify-content: space-between;
}

.col1 {
  width: 100%;
}
.col2 {
  text-align: right;
  width: 200px;
}
.col3 {
  text-align: right;
  width: 200px;
}

@media (min-height: 760px) {
  .main-lossAndEfficiency {
    height: 655px;
  }
}

@media (min-height: 900px) {
  .main-lossAndEfficiency {
    height: 735px;
  }
}

@media (min-height: 1050px) {
  .main-lossAndEfficiency {
    height: 845px;
  }
}

@media (min-height: 1050px) {
  .main-lossAndEfficiency {
    height: 845px;
  }
}

@media (min-height: 1600px) {
  .main-lossAndEfficiency {
    height: 1395px;
  }
}
</style>
